import { Colors, pxToRem } from '@back-office/core';
import { Theme } from '@material-ui/core';
import Typography, { TypographyProps } from '@material-ui/core/Typography';
import { Property } from 'csstype';
import React from 'react';
import styled from 'styled-components';

interface GcpTypographyProps extends TypographyProps {
  paint?: keyof Colors;
  transform?: Property.TextTransform;
  theme?: Theme;
  weight?: Property.FontWeight;
  spacing?: Property.LetterSpacing;
  size?: number;
  whiteSpace?: Property.WhiteSpace;
  textAlign?: Property.TextAlign;
  wordBreak?: Property.WordBreak;
  lineHeight?: number;
}

const GcpTypography = styled(
  ({
    paint,
    transform,
    weight,
    spacing,
    size,
    textAlign,
    whiteSpace,
    wordBreak,
    lineHeight,
    ...rest
  }: GcpTypographyProps) => <Typography {...rest} />
)<GcpTypographyProps>`
  color: ${(props): string =>
    props.paint ? props.theme.palette?.common[props.paint] : 'initial'};
  text-transform: ${(props): string => props.transform || 'none'};
  ${(props): string => props.weight && `font-weight: ${props.weight}`};
  ${(props): string => props.spacing && `letter-spacing: ${props.spacing}`};
  ${(props): string =>
    props.size && `font-size: ${pxToRem(props.size)} !important`};
  ${(props): string => props.whiteSpace && `white-space: ${props.whiteSpace}`};
  ${(props): string => props.textAlign && `text-align: ${props.textAlign}`};
  ${(props): string => props.wordBreak && `word-break: ${props.wordBreak}`};
  ${(props): string => props.lineHeight && `line-height: ${props.lineHeight}`};
`;

export default GcpTypography;
